export const USER_NOT_FOUND = 'USER_NOT_FOUND';
export const USER_NOT_FOUND_DUPLICATE = 'USER_NOT_FOUND_DUPLICATE';

const locale =
  (navigator.languages && navigator.languages[0]) ||
  navigator.language ||
  // tslint:disable-next-line:no-string-literal
  window.navigator['userLanguage'] ||
  'en-US';

let loc = locale.substring(0, locale.indexOf('-'));

const notfound =
  loc !== 'fr'
    ? 'We could not find your account. Please try another sign in method'
    : 'Nous n`avons pas pu trouver votre compte. Veuillez essayer une autre méthode de connexion';
const multipleaccounts =
  loc !== 'fr'
    ? 'More than one account matched this email. Please try another sign in method'
    : 'Plus d`un compte correspond à ce courriel. Veuillez essayer une autre méthode de connexion';
export const errorMessageMap = new Map();
errorMessageMap.set(USER_NOT_FOUND, notfound);
errorMessageMap.set(USER_NOT_FOUND_DUPLICATE, multipleaccounts);



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/app/login/errors.ts